export default "__VITE_ASSET__Chc8dq5N__"